<template>
  <span>
    Copyright © 2012 - {{ new Date().getUTCFullYear() }} GC集團 Ltd All Rights
    Reserved.{{ version }}
  </span>
</template>
<script>
export default {
  data () {
    return {
      version: require('../../../package.json').version
    }
  }
}
</script>
